"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _moment = _interopRequireDefault(require("moment"));

var _emotion = require("emotion");

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _Icon = _interopRequireDefault(require("@cimpress/react-components/lib/Icon"));

var _shapes = _interopRequireDefault(require("./shapes"));

var _contractSelectorMessages = require("./contractSelectorMessages");

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n      align-items: center;\n      cursor: pointer;\n      background-color: ", ";\n      border: 1px solid ", ";\n      box-shadow: 0 2px 4px 0 rgba(196, 205, 214, 0.5);\n      height: 95px;\n      padding: 10px;\n      &:not(:last-child) {\n        margin-bottom: 10px;\n      }\n      &:hover {\n        border: 1px solid ", ";\n        background: ", ";\n      }\n    }"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  flex: 1 0 50px;\n  align-self: center;\n  text-align: right;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    overflow: hidden;\n    margin: 0;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  flex: 2 0 150px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  flex: 1 0 100px;\n  min-width: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 12px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var infoStyle = (0, _emotion.css)(_templateObject());
var subtitleStyle = (0, _emotion.css)(_templateObject2(), colors.slate);
var contractDetailStyle = (0, _emotion.css)(_templateObject3());
var contractNameStyle = (0, _emotion.css)(_templateObject4());
var contractInfoStyle = (0, _emotion.css)(_templateObject5());
var titleStyle = (0, _emotion.css)(_templateObject6());
var toggleStyle = (0, _emotion.css)(_templateObject7());

var ContractOption =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ContractOption, _PureComponent);

  function ContractOption() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ContractOption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ContractOption)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onSelect = function (selected) {
      var _this$props = _this.props,
          contract = _this$props.contract,
          onSelect = _this$props.onSelect;
      onSelect(selected ? contract : null);
    };

    _this.getBackgroundColor = function () {
      var selected = _this.props.selected;
      return selected ? colors.horizon : colors.white;
    };

    _this.getBackgroundColor = function () {
      var selected = _this.props.selected;
      return selected ? colors.horizon : colors.white;
    };

    _this.getBorderColor = function () {
      var selected = _this.props.selected;
      return selected ? colors.ocean.base : colors.alloy;
    };

    _this.getContainerStyle = function () {
      return (0, _emotion.css)(_templateObject8(), _this.getBackgroundColor(), _this.getBorderColor(), colors.ocean.base, colors.horizon);
    };

    return _this;
  }

  (0, _createClass2.default)(ContractOption, [{
    key: "renderModifier",
    value: function renderModifier() {
      var _this$props2 = this.props,
          contract = _this$props2.contract,
          formatMessage = _this$props2.intl.formatMessage;

      if (!contract.modifiers || !contract.modifiers.markupPercent && !contract.modifiers.discountPercent) {
        return null;
      }

      return contract.modifiers.discountPercent ? _react.default.createElement("div", {
        className: contractDetailStyle
      }, formatMessage(_contractSelectorMessages.contractSelectorMessages.discount), ": ", contract.modifiers.discountPercent, "%") : _react.default.createElement("div", {
        className: contractDetailStyle
      }, formatMessage(_contractSelectorMessages.contractSelectorMessages.markup), ": ", contract.modifiers.markupPercent, "%");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          contract = _this$props3.contract,
          selected = _this$props3.selected,
          _this$props3$intl = _this$props3.intl;
      _this$props3$intl = _this$props3$intl === void 0 ? this.props : _this$props3$intl;
      var formatMessage = _this$props3$intl.formatMessage;
      var createdDate = (0, _moment.default)(contract.createdAt).format('YYYY-MM-DD');
      var modifierDiv = this.renderModifier();
      return _react.default.createElement("div", {
        className: (0, _emotion.cx)(this.getContainerStyle(), className),
        onClick: this.onSelect
      }, _react.default.createElement("div", {
        className: infoStyle
      }, _react.default.createElement("div", {
        className: contractNameStyle
      }, _react.default.createElement("div", {
        className: (0, _emotion.cx)('h5', titleStyle)
      }, contract.additionalData.name), _react.default.createElement("div", {
        className: subtitleStyle
      }, formatMessage(_contractSelectorMessages.contractSelectorMessages.revision), " ", contract.revisionId)), _react.default.createElement("div", {
        className: contractInfoStyle
      }, _react.default.createElement("div", {
        className: contractDetailStyle
      }, _react.default.createElement("b", null, formatMessage(_contractSelectorMessages.contractSelectorMessages.contractDetails))), _react.default.createElement("div", {
        className: contractDetailStyle
      }, formatMessage(_contractSelectorMessages.contractSelectorMessages.items), ": ", contract.itemsCount), modifierDiv, _react.default.createElement("div", {
        className: contractDetailStyle
      }, formatMessage(_contractSelectorMessages.contractSelectorMessages.lastModified), ": ", createdDate), _react.default.createElement("div", {
        className: contractDetailStyle
      }, formatMessage(_contractSelectorMessages.contractSelectorMessages.lastModifiedBy), ": ", contract.createdBy)), _react.default.createElement("div", {
        className: toggleStyle
      }, selected ? _react.default.createElement(_Icon.default, {
        color: colors.ocean.base,
        name: "check-circle-2-f",
        size: "lg"
      }) : null)));
    }
  }]);
  return ContractOption;
}(_react.PureComponent);

var _default = (0, _reactIntl.injectIntl)(ContractOption);

exports.default = _default;